import React from "react";
import { ArrowRight, Award, Users, Star } from "lucide-react";
import heroImage from "../assets/hero-wood-workshop.jpg";
import "../styles/Hero.css";

const Hero = () => {
    const scrollTo = (e, sel) => {
        e.preventDefault();
        document.querySelector(sel)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section id="inicio" className="hero">
            <div className="hero-bg" style={{ backgroundImage: `url(${heroImage})` }}>
                <div className="hero-overlay" />
            </div>

            <div className="hero-content">
                <h1>
                    Mais Estilo&nbsp; 
                    <br />
                    <span>Ao Seu Projeto</span>
                </h1>

                <p>
                    Transformamos madeira de demolição em móveis únicos e sofisticados.
                    Cada peça conta uma história, trazendo elegância e exclusividade para
                    ambientes de alto padrão.
                </p>

                <div className="hero-buttons">
                    <a href="#produtos" className="btn-primary" onClick={(e) => scrollTo(e, "#produtos")}>
                        Ver Nossos Produtos <ArrowRight size={20} />
                    </a>
                    <a href="#contato" className="btn-outline" onClick={(e) => scrollTo(e, "#contato")}>
                        Solicitar Orçamento
                    </a>
                </div>

                <div className="hero-stats">
                    <div className="stat">
                        <Award size={32} />
                        <h3>15+</h3>
                        <p>Anos de Experiência</p>
                    </div>
                    <div className="stat">
                        <Users size={32} />
                        <h3>500+</h3>
                        <p>Projetos Realizados</p>
                    </div>
                    <div className="stat">
                        <Star size={32} />
                        <h3>100%</h3>
                        <p>Clientes Satisfeitos</p>
                    </div>
                </div>
            </div>

            <div className="scroll-indicator">
                <div className="scroll-dot"></div>
            </div>
        </section>
    );
};

export default Hero;